import { mutationTypes } from '@helpers/storeFactories/helpers';

export default {
    [mutationTypes.SELECT_ITEMS](state, ids) {
        ids.forEach((id) => {
            state.listMap[id]._selected = true;
        });
    },
    [mutationTypes.DESELECT_ITEMS](state, ids) {
        ids.forEach((id) => {
            state.listMap[id]._selected = false;
        });
    },
    [mutationTypes.SELECT_ALL_ITEMS](state) {
        state.list.forEach((item) => {
            state.listMap[item.id]._selected = true;
        });
    },
    [mutationTypes.DESELECT_ALL_ITEMS](state) {
        state.list.forEach((item) => {
            state.listMap[item.id]._selected = false;
        });
    },
};
